/* Built In Imports */
import { useState, useEffect } from 'react';

/* External Imports */
import { Box, Button, Center, Radio, RadioGroup, Text, Flex, ChakraProvider } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { refineUrlDomain } from '@components/Utility/utils';
import config from '@config';
import NoSeatingAvailable from '@landing_pages/eoe/components/NoSeatingAvailable';
import { useEOEContext } from '@store/EOEContext';

/* Service */
import { searchByFieldId } from '@components/Utility/Shared/SharedService';

/* Services */
import { getCurrentRegion } from 'services/commonService';

/**
 *
 * @param {Object} sectionContent
 * @returns
 */
const SeatingLayoutEightRow = ({
  sectionContent,
  region,
  lang,
  pageData,
  listTicket,
  setListTicket,
  isCityClicked,
  selTab,
}) => {
  let appendUrlParameter = '';
  if (lang === 'hi') {
    appendUrlParameter = "&lang=hi_IN";
  } else {
    appendUrlParameter = '';
  }
  
  const [tokenId, setTokenId] = useState('');
  const [currRegion, setCurrRegion] = useState('in');

    useEffect(() => {
      (async () => {
        /* Logging the value of currRegion and currRegion?.country?.toLowerCase() */
        let cRegion;
        try {
          cRegion = await getCurrentRegion();
          // console.log('cRegion', cRegion);
          setCurrRegion(cRegion?.country?.toLowerCase());
        } finally {
          if (cRegion?.length === 0) {
            setCurrRegion('in');
          }
        }
      })();
    }, []);

  const listEventTicketRow = index => {
    const ticket = listTicket?.tickets?.[index];
    if (!ticket) return null;

    const { name, json_pricing } = ticket;
    let price = json_pricing?.base?.original_price;
    let discountedPrice = json_pricing?.base?.price;

    const getColorForIndex = index => {
      switch (index) {
        case 1:
          return '#185171';
        case 2:
          return '#562D2F';
        case 3:
          return '#0E3F3C';
        case 4:
          return '#0E3F4F';
        case 5:
          return '#0E3F3C';
        case 6:
          return '#562D2F';
        case 7:
          return '#185171';
        default:
          return 'inherit';
      }
    };

    let InrRupees = new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
    });

    return (
      <Box
        height={{ base: '52px', md: '70px' }}
        w={{base:"100px", sm:"100px",md:'160px' }}
        mx="auto"
        boxSizing="content-box"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        {ticket?.json_pricing?.limited_seats_flag && (
          <Box
            bgColor="#D70000"
            color="#fff"
            fontSize={{ base: '8px', md: '10px' }}
            position="absolute"
            py={{ base: 1, md: 2 }}
            px={{ base: 2, md: 3 }}
            width={{ base: '66px', md: 'auto' }}
            fontFamily="'FedraSansStd-book'"
            zIndex="2"
            left="-6px"
            top="10px"
            _before={{
              width: 0,
              height: 0,
              content: "''",
              borderRight: '6px solid #870000',
              borderBottom: '6px solid transparent',
              borderTop: '0px solid #870000',
              position: 'absolute',
              left: 0,
              bottom: '-6px',
            }}
          >
            Limited Seats Available
          </Box>
        )}

        <Box
          key={index}
        >
          {ticket?.seats_available > 0 && (
            <>
              {name && (
                <RadioGroup
                  onChange={setTokenId}
                  value={tokenId}
                  size={{base:"sm", sm:"sm", md:"md"}}
                  name={name}
                  marginLeft={"10px"}
                >
                  <Radio
                    value={currRegion == "in" ? ticket?.cat_in : ticket?.cat_ov}
                    //key={nanoid(2)}
                    //isInvalid
                    bg="white"
                    border="none"
                    _checked={{
                      background: 'none',
                      border: '2px solid #fff',
                      //outline: '2px solid #fff',
                      outlineOffset: '-5px',
                    }}
                  >
                    <Box
                      fontFamily="FedraSansStd-book"
                      fontSize={{ base: '9px', md: '16px' }}
                      fontWeight={"600"}
                    >
                      {name}
                    </Box>
                  </Radio>
                </RadioGroup>
              )}

              <Box
                display="flex"
                flexDir="column"
                fontSize={{ base: '9px', md: '16px' }}
                fontWeight={"600"}
                paddingLeft={{base:"30px", sm:"30px", md:"35px"}}
                fontFamily="FedraSansStd-book"
                lineHeight={{base:"15px", sm:"15px", md:"25px"}}
              >
                   <>
                    <Text>
                      { discountedPrice === "Free" ? "Free" : InrRupees.format(discountedPrice) .replace('₹', 'INR ') .replace('.00', '')
                      }
                    </Text>
                    {discountedPrice != price && (
                      <Text
                        as="del"
                        fontFamily="FedraSansStd-book"
                        color={getColorForIndex(index)}
                      >
                        {InrRupees.format(price)
                          .replace('₹', 'INR ')
                          .replace('.00', '')}
                      </Text>
                    )}
                  </>
                
              </Box>
            </>
          )}
          {name && !ticket?.seats_available ? (
            <NoSeatingAvailable
              name={name}
              price={price}
              discountedPrice={discountedPrice}
            />
          ) : (
            <></>
          )}
        </Box>
      </Box>
    );
  };


  const gtmClick = () => {
    // debugger;
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        event: 'MSR_Seating_Pass',
        //IE_status: isIeDone ? 'Yes' : 'No',
        //IE_Lang: ieLang,
        city: "Coimbatore",
      });

      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: '',
          value: '',
          items: [
            {
              item_id: city, // id of the program
              item_name:"MSR Seating Pass",
              affiliation: '',
              coupon: '',
              discount: '',
              index: '',
              //item_brand: isIeDone ? 'Yes' : 'No', //IE Status <Yes/No>
              //item_category: ieLang, //IE Lang (User selected IE Language Ex- MR,EN,HI)
              item_category2: '',
              item_category3: '',
              item_category4: '',
              item_category5: '',
              item_list_id: '',
              item_list_name: '',
              item_variant: '',
              location_id: "Coimbatore",
              price: '',
              quantity: '',
            },
          ],
        },
      });
    }
  };

  return (
      <Box
        display="flex"
        flexDir="column"
        alignItems="center"
        fontFamily="FedraSansStd-book"
      >
        <Box mb={{ base: '-7px', sm:"", md:'-6px', md: '' }} textAlign={'center'}
         w={{base:"146px", sm:"146px", md:"100%"}}
        >
          <img
            alt="adiyogi"
            title="adiyogi"
            src={`${config.imgPath}/d/46272/1742432066-msr_seating_adiyogi.png`}
          />
        </Box>
        <Box
         w={{base:"146px", sm:"146px", md:"179px"}}
         h={{base:"38px", sm:"38px", md:"43px"}}
         bg={"#E0E0CE"}
         color={"#151515"}
         fontSize={"10px"}
         fontWeight={"600"}
         textAlign={"center"}
         borderBottom={"2px solid #000"}
         borderTop={"1px solid #000"}
         fontFamily="FedraSansStd-book"
         padding={{base:"2px", sm:"2px", md:"5px"}}
       >   
       <Box>
           <img
            alt="Yogeshwar Linga"
            title="Yogeshwar Linga"
            src={`${config.imgPath}/d/46272/1742963504-shiva_linga.png`}
          />
       </Box>
           Yogeshwar Linga
       </Box>
       <Box
         w={{base:"146px", sm:"146px", md:"179px"}}
         h={{base:"39px",sm:"39px", md:"77px"}}
         bg={"#E0E0CE"}
         fontWeight={"600"}
         fontFamily="FedraSansStd-book"
         color={"#151515"}
         fontSize={{base:"12px", sm:"12px", md:"14px"}}
         textAlign={"center"}
         borderBottom={"3px solid #000"}
         padding={{base:"8px", sm:"8px", md:"25px"}}
       >
           Dais
       </Box>
      <Box
        w={{ base: '288px', sm: '288px', md: '551px' }}
        display="flex"
        justifyContent="center"
        flexDir="column"
        alignItems="center"
        //className="boxSixLayout"
      >
        <Box
          w={{ base: '288px', sm: '288px', md: '551px' }}
          bg={"#C1C1C1"}
          height={{base:"181.9px", sm:"181.9px", md: "300px"}}
          marginBottom={"-2px"}
        >
      <ChakraProvider>
      <Box>        <Flex
          direction={"row"} 
        >
          {/* First Column with custom width */}
          <Box
            color={"#FFF"}
            justifyContent={"middle"}
            fontFamily="FedraSansStd-book"
            fontSize={{base:"11px", sm:"11px", md:"16px"}}
            textAlign={"center"}
            w={{base:"143px", sm:"143px", md:"274px"}}
            h={"303px"}
            py={{base:"27%", sm:"27%", md:"24%"}}
            fontWeight={"600"}
           >
            <Text>Reserved</Text>
          </Box>

          {/* Second Column with custom width */}
          <Box
           //marginLeft={{base:"22%", sm:"22%", md:"30%"}}
          >
            <Box
          bg={"#8980FA"}
          color={"#fff"}
          as="label"
          cursor={
            !listTicket?.tickets[2]?.seats_available ? 'default' : 'pointer'
          }
          display="flex"
          justifyContent="center"
          alignContent="center"
          borderLeft={"3px solid #000"}
          borderRight={"3px solid #000"}
          borderBottom={"1px solid #000"}
          //border={{ base: '1px solid #000', md: '1px solid #000' }}
          boxSizing="border-box"
          height={{base:"60px", sm:"60px", md:"99.25px"}}
          w={{ base: '90px', sm: '90px', md: '135.65px' }}
          className="box1"
          //marginLeft={"25%"}
          fontSize={{base:"9px", sm:"9px", md:"16px"}}
          fontFamily="FedraSansStd-book"
          paddingTop={{base:"0px",sm:"0px", md:"10px"}}
        >
          {listEventTicketRow(0)}
        </Box>
        <Box
          bg={"#A1AE10"}
          color={"#fff"}
          as="label"
          cursor={
            !listTicket?.tickets[2]?.seats_available ? 'default' : 'pointer'
          }
          display="flex"
          justifyContent="center"
          alignContent="center"
          //border={{ base: '1px solid #000', md: '1px solid #000' }}
          borderTop={'2px solid #000' }
          borderLeft={"3px solid #000"}
          borderRight={"3px solid #000"}
          borderBottom={"1px solid #000"}
          boxSizing="border-box"
          height={{base:"60px", sm:"60px", md:"99.25px"}}
          w={{ base: '90px', sm: '90px', md: '135.65px' }}
          className="box2"
          //marginLeft={"25%"}
          fontSize={{base:"9px", sm:"9px", md:"16px"}}
          fontFamily="FedraSansStd-book"
          paddingTop={{base:"0px",sm:"0px", md:"10px"}}
        >
          {listEventTicketRow(1)}
        </Box>
        <Box
          bg={"#DC7152"}
          color={"#fff"}
          as="label"
          cursor={
            !listTicket?.tickets[2]?.seats_available ? 'default' : 'pointer'
          }
          display="flex"
          justifyContent="center"
          alignContent="center"
          //border={{ base: '1px solid #000', md: '1px solid #000' }}
          borderTop={'2px solid #000' }
          borderLeft={"3px solid #000"}
          borderRight={"3px solid #000"}
          boxSizing="border-box"
          height={{base:"60px", sm:"60px", md:"99.25px"}}
          w={{ base: '90px', sm: '90px', md: '135.65px' }}
          className="box3"
          //marginLeft={"25%"}
          bottom={"-2px"}
          fontSize={{base:"9px", sm:"9px", md:"16px"}}
          fontFamily="FedraSansStd-book"
          paddingTop={{base:"0px",sm:"0px", md:"10px"}}
        >
          {listEventTicketRow(2)}
        </Box>
          </Box>

          {/* Third Column with custom width */}
          <Box
            color={"#FFF"}
            textAlign={"center"}
            fontFamily="FedraSansStd-book"
            fontSize={{base:"11px", sm:"11px", md:"16px"}}
            w={{base:"70.9px", sm:"70.9px", md:"135px"}}
            height={"303px"}
            py={{base:"27%", sm:"27%", md:"24%"}}
            fontWeight={"600"}
          >
            <Text>Reserved</Text>
          </Box>
        </Flex>
      </Box>
    </ChakraProvider>
        </Box>
        <Box
          as="label"
          cursor={
            !listTicket?.tickets[3]?.seats_available ? 'default' : 'pointer'
          }
          display="flex"
          justifyContent="center"
          alignContent="center"
          bg={"#9D72B8"}
          color={'#fff'}
          w={{ base: '100%', md: '551px' }}
          borderTop={'3px solid #000' }
          borderBottom={"1px solid #000"}
          className="box4"
          position="relative"
          height={{ base: '52px', md: '72.72px' }}
          fontSize={{base:"9px", sm:"9px", md:"16px"}}
          fontFamily="FedraSansStd-book"
        >
          {listEventTicketRow(3)}
        </Box>
        <Box
          bg={"#FBAC45"}
          color={"#fff"}
          height={{ base: '52px', md: '72.72px' }}
          //borderBottom={{ base: '6px solid #fff', md: '10px solid #fff' }}
          borderTop={'2px solid #000' }
          borderBottom={"1px solid #000"}
          //border={{ base: '1px solid #000', md: '1px solid #000' }}
          boxSizing="content-box"
          w={{ base: '100%', md: '551px' }}
          className="box5"
          position="relative"
          as="label"
          cursor={
            !listTicket?.tickets[4]?.seats_available ? 'default' : 'pointer'
          }
          fontSize={{base:"9px", sm:"9px", md:"16px"}}
          fontFamily="FedraSansStd-book"
        >
          {listEventTicketRow(4)}
        </Box>
        <Box
          bg={"#B24D90"}
          color={"#fff"}
          height={{ base: '52px', md: '72.72px' }}
          //borderRadius="0 0 12px 12px "
          //border={{ base: '1px solid #000', md: '1px solid #000' }}
          borderTop={'2px solid #000' }
          borderBottom={"1px solid #000"}
          boxSizing="border-box"
          w={{ base: '100%', md: '551px' }}
          className="box6"
          as="label"
          cursor={
            !listTicket?.tickets[5]?.seats_available ? 'default' : 'pointer'
          }
          fontSize={{base:"9px", sm:"9px", md:"16px"}}
          fontFamily="FedraSansStd-book"
        >
          {listEventTicketRow(5)}
        </Box>
        <Box
          bg={
            listTicket?.tickets[6]?.seats_available < 1
              ? '#45478D'
              : tokenId == listTicket?.tickets[6].token
              ? '#45478D'
              : '#45478D'
          }
          color={
            listTicket?.tickets[6]?.seats_available
              ? '#fff'
              : tokenId == listTicket?.tickets[6].token && '#fff'
          }
          height={{ base: '52px', md: '72.72px' }}
          //borderRadius="0 0 12px 12px "
          borderTop={'2px solid #000' }
          borderBottom={"1px solid #000"}
          boxSizing="border-box"
          w={{ base: '100%', md: '551px' }}
          className="box7"
          as="label"
          cursor={
            !listTicket?.tickets[6]?.seats_available ? 'default' : 'pointer'
          }
          fontSize={{base:"9px", sm:"9px", md:"16px"}}
          fontFamily="FedraSansStd-book"
        >
          {listEventTicketRow(6)}
        </Box>
        <Box
          bg={"#6DB4BE"}
          color={"#fff"}
          height={{ base: '52px', md: '72.72px' }}
          //borderRadius="0 0 12px 12px "
          borderTop={'2px solid #000' }
          borderBottom={"1px solid #000"}
          boxSizing="border-box"
          w={{ base: '100%', md: '551px' }}
          className="box8"
          as="label"
          cursor={
            !listTicket?.tickets[7]?.seats_available ? 'default' : 'pointer'
          }
          fontSize={{base:"9px", sm:"9px", md:"16px"}}
          fontFamily="FedraSansStd-book"
        >
          {listEventTicketRow(7)}
        </Box>
      </Box>

      <Box
        w={{base:"280px", sm:"280px", md:"350px"}}
        fontWeight="400"
        fontStyle={"italic"}
        margin={"auto"}
        justifyContent={"center"}
        py={"10px"}
      >
      <StructuredTextParser
        fontFamily="FedraSansStd-book"
        str={render(sectionContent[2].body)}
        color="#FFFFFF"
        fontSize={{base:"16px", sm:"16px", md:"18px"}}
        textAlign={"center"}
      />
    </Box>
      <Box py="20px">
        {sectionContent[3]?.buttonText && (
          <Button
            disabled={!tokenId}
            fontFamily="FedraSansStd-book"
            fontWeight="600"
            color="#000000"
            fontSize={"16px"}
            className="btn_set"
            cursor={tokenId ? 'pointer' : 'not-allowed'}
            background={tokenId ? '#FFA735' : '#333333'}
            _hover={{
              background: tokenId ? '#FFA735' : '#333333',
            }}
            px={"23px"}
            py={"15px"}
            borderRadius={"5px"}
            maxW={"149px"}
            height={"56px"}
            onClick={() => {
              if (tokenId) {
                //gtmClick();
                window.open(
                  refineUrlDomain(`${config.MSR_EVENT_DOMAIN}/event/${currRegion == "in" ? config.MSR_EVENT_IN_ID : config.MSR_EVENT_OV_ID}/register?category=${tokenId}`),
                  '_blank'
                );
              }
            }}
          >
            {sectionContent[3].buttonText}
          </Button>
        )}
      </Box>
      <style jsx global>
        {`
          .boxSixLayout {
            position: relative;
            padding-top: 40px;
          }
          .box1:hover {
            background: #8980FA;
            color: #fff;
          }
          .box2:hover {
            background:#B7C235;
            color: #fff;
          }
          .box2:hover del {
            color: #fff;
          }
          .box3:hover {
            background: #F38868;
            color: #fff;
          }
          .box3:hover del {
            color: #fff;
          }
          .btn_set{
            opacity: 1 !important;
          }
          .box4:hover {
            background: #B388CD;
            color: #fff;
          }
          .box4:hover del {
            color: #fff;
          }
          .box5:hover {
            background: #FFBB63;
            color: #fff;
          }
          .box5:hover del {
            color: #fff;
          }
          .box6:hover {
            background: #C466A4;
            color: #fff;
          }
          .box6:hover del {
            color: #fff;
          }
          .box7:hover {
            background: #5E61A2;
            color:#fff;
          }
          .box7:hover del {
            color: #fff;
          }
          .box8:hover {
            background: #84C5CE;
            color: #fff;
          }
          .box8:hover del {
            color: #fff;
          }
        `}
      </style>
    </Box>
  );
};

export default SeatingLayoutEightRow;
